import * as React from "react";

export const renderArrow = (componentPrefix: string) => {
    return (
        <div className={`rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__arrow-wrap`}>
            <span className={`rj-ev-list__${componentPrefix}__arrow`}></span>
        </div>
    )
}